<template>
  <div class="d-flex flex-column py-5">
    <div class="d-flex justify-space-between">
      <div class="d-block text-h6 black--text font-weight-bold mt-4">Informasi Tokomu</div>
      <div
        class="d-block subtitle-1 red--text mr-4 mt-4 cursor-pointer text-right"
        v-if="userData"
        @click="copyme"
      >
        <span>
          <span class="pl-1">Bagikan Tautan Toko</span>
          <input type="hidden" :value="getUrlReferal()" id="inputCopy" />
        </span>
      </div>
    </div>
    <v-layout v-resize="onResize" column>
      <v-row v-if="profile">
        <v-col cols="12" sm="4">
          <v-card class="my-4">
            <!-- <v-img
              height="200"
              :loading="loading"
              :src="(stores_image) ? stores_image : '/assets/icons/default-toko.svg'"
            ></v-img> -->
            <v-row>
              <v-col cols="6" md="12" class="py-0 d-flex justify-center">
                <!-- <v-img height="200" class="rounded-lg" :src="detailProfile.user_image ? detailProfile.user_image : '/assets/icons/default-toko.svg'"></v-img> -->
                <v-img
                  v-if="stores_image"
                  width="70"
                  height="70"
                  class="mx-auto rounded-circle"
                  :src="stores_image ? stores_image : '/assets/seller/default-toko.svg'"
                ></v-img>
                <v-avatar v-else size="200"
                  ><v-img src="/assets/seller/default-toko.svg"></v-img
                ></v-avatar>
              </v-col>
            </v-row>
            <div class="text-caption pa-3 my-2">
              Format gambar .jpg .jpeg .png dan ukuran minimum 300 x 300 px (Untuk gambar optimal
              gunakan minimum 700 x 700 px)
            </div>
            <v-card-text>
              <v-file-input
                v-show="false"
                accept="image/*"
                id="inputImage"
                v-model="imgUpload"
                @change="handleFileUpload($event)"
                truncate-length="50"
                small-chips
                outlined
                dense
                hide-details="auto"
                prepend-icon=""
                :clearable="false"
                placeholder="GANTI FOTO"
                class="mt-md-3 text-body-2 rounded-lg file-button"
              ></v-file-input>
              <v-btn color="#272727" outlined block :loading="loadingProcess" @click="openUpload">
                <strong>Ganti Gambar Toko</strong>
              </v-btn>
            </v-card-text>
            <v-divider class="mx-4"></v-divider>
            <v-card-text v-if="false">
              <div
                class="font-weight-bold primary--text text-center text-uppercase"
                v-if="profile.store_is_b2b == 'true'"
              >
                Mitra B2B Store
              </div>
              <v-btn
                color="primary"
                outlined
                block
                :loading="loadingProcess"
                @click="openConfirmB2b"
                v-else
              >
                <strong>Daftar B2B Store</strong>
              </v-btn>
            </v-card-text>
            <v-divider class="mx-4"></v-divider>
            <v-card-text>
              <div class="font-weight-bold black--text text-uppercase">
                {{ profile.store_name }}
              </div>
            </v-card-text>
            <v-divider class="mx-4"></v-divider>
            <v-card-text>
              <div class="subtitle-1">
                Dibuat pada :
              </div>

              <div>{{ formatDateText(profile.store_input_datetime, "DD MMMM YYYY HH:mm") }}</div>
            </v-card-text>
            <v-divider class="mx-4"></v-divider>
            <v-card-text>
              <div class="subtitle-1">
                Deskripsi Toko
              </div>

              <div v-if="!onEdit">{{ profile.store_description }}</div>
              <div v-else>
                <v-textarea
                  v-model="store_description"
                  :rules="descriptionRules"
                  outlined
                  class="rounded-lg text-body-1"
                  dense
                  placeholder="Deskripsi Toko"
                  @focus="() => (responseError.store_description = '')"
                  :error-messages="responseError.store_description"
                  hint="Maksimal 200 karakter"
                  persistent-hint
                ></v-textarea>
              </div>
              <div class="text-right mt-3" v-if="!onEdit">
                <v-btn
                  text
                  class="primary--text"
                  @click="
                    onEdit = true;
                    store_description = profile.store_description;
                  "
                  >UBAH</v-btn
                >
              </div>
              <div class="text-right mt-3" v-else>
                <v-btn text class="error--text pr-3" @click="cancelEdit">BATAL</v-btn>
                <v-btn text class="primary--text" @click="saveEdit">SIMPAN</v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="8" :class="{ 'px-7': !isMobile }">
          <v-card class="mx-0" :class="{ 'my-4': !isMobile }" flat>
            <v-card-text class="px-0 py-0">
              <v-row>
                <v-col cols="12" sm="4" class="pt-0">
                  <v-card>
                    <v-card-title class="d-block text-center text-subtitle-2 black--text"
                      >Produk</v-card-title
                    >
                    <v-divider class="mx-0"></v-divider>
                    <v-card-text>
                      <div class="d-block text-h4 primary--text text-center">
                        {{ profile.store_stock.length }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="4" class="pt-0">
                  <v-card>
                    <v-card-title class="d-block text-center text-subtitle-2 black--text"
                      >Penjualan</v-card-title
                    >
                    <v-divider></v-divider>
                    <v-card-text>
                      <div class="d-block text-h4 primary--text text-center">
                        {{ profile.store_trx_count }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="4" class="pt-0">
                  <v-card>
                    <v-card-title class="d-block text-center text-subtitle-2 black--text"
                      >Pembelian</v-card-title
                    >
                    <v-divider class="mx-4"></v-divider>
                    <v-card-text>
                      <div class="d-block text-h4 primary--text text-center">
                        {{ profile.store_po_count }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card class="my-4">
            <v-card-title class="text-subtitle-1 font-weight-bold">
              <v-row>
                <v-col cols="12" sm="6" class="py-0">
                  Info Akun Bank
                </v-col>
                <v-col cols="12" sm="6" :class="{ 'py-0 text-right': !isMobile }">
                  <v-btn
                    small
                    text
                    elevation="0"
                    class="text-capitalize"
                    :class="{ 'v-btn--outlined v-btn--block v-size--default': isMobile }"
                    @click="openModule('/seller/rekening-bank')"
                  >
                    <v-icon class="mr-2 grey--text">mdi-cog-outline</v-icon> Pengaturan
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider class="mx-4"></v-divider>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6" :class="{ 'pt-0': isMobile }">
                  <div class="subtitle-1">Nama Bank</div>
                  <div>{{ profile.store_bank_name | emptyData }}</div>
                </v-col>
                <v-col cols="12" sm="6" :class="{ 'pt-0': isMobile }">
                  <div class="subtitle-1">Cabang</div>
                  <div>{{ profile.store_bank_branch | emptyData }}</div>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="6" :class="{ 'pt-0': isMobile }">
                  <div class="subtitle-1">Nomor Rekening</div>
                  <div>{{ profile.store_bank_account_number | emptyData }}</div>
                </v-col>
                <v-col cols="12" sm="6" :class="{ 'pt-0': isMobile }">
                  <div class="subtitle-1">Nama Rekening Pemilik</div>
                  <div>{{ profile.store_bank_account_name | emptyData }}</div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card class="my-4">
            <v-card-title class="text-subtitle-1 font-weight-bold">
              <v-row>
                <v-col cols="12" sm="6" class="py-0">
                  Info Pengiriman
                </v-col>
                <v-col cols="12" sm="6" class="text-right" :class="{ 'py-0': !isMobile }">
                  <v-btn
                    small
                    text
                    elevation="0"
                    class="text-capitalize"
                    :class="{ 'v-btn--outlined v-btn--block v-size--default': isMobile }"
                    @click="openModule('/seller/pengaturan-pengiriman')"
                  >
                    <v-icon class="mr-2 grey--text">mdi-cog-outline</v-icon> Pengaturan
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider class="mx-4"></v-divider>
            <v-card-text>
              <v-row>
                <v-col
                  cols="6"
                  sm="4"
                  v-for="(kurir, idx) in JSON.parse(profile.store_courier)"
                  :key="idx"
                >
                  <div class="d-flex flex-column align-center justify-center">
                    <div class="subtitle-1 text-uppercase mb-2">{{ kurir }}</div>
                    <v-img
                      width="100"
                      max-width="auto"
                      :src="'/assets/courier/' + kurir + '.svg'"
                    ></v-img>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>
    <v-dialog v-model="dialogB2b" persistent scrollable max-width="700">
      <v-card>
        <v-card-title class="text-h6 text-h6 text-capitalize black--text darken-4">
          Pendaftaran Mitra B2B
        </v-card-title>
        <v-card-text>
          <v-form ref="formB2b" role="form">
            <v-row class="align-center">
              <v-col cols="12" sm="3" class="py-xs-0"
                ><div class="d-block text-subtitle-2 font-weight-bold black--text">
                  Nama Perusahaan
                </div></v-col
              >
              <v-col cols="12" sm="7">
                <v-text-field
                  v-model="paramsB2b.company_name"
                  :rules="rulesB2b.company_name"
                  single-line
                  outlined
                  class="rounded-lg text-body-1"
                  height="45"
                  dense
                  placeholder="Nama Perusahaan"
                  hide-details="auto"
                  @focus="() => (responseError.company_name = '')"
                  :error-messages="responseError.company_name"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="align-center">
              <v-col cols="12" sm="3" class="py-xs-0"
                ><div class="d-block text-subtitle-2 font-weight-bold black--text">
                  Nama Toko
                </div></v-col
              >
              <v-col cols="12" sm="7">
                <v-text-field
                  v-model="paramsB2b.store_name"
                  :rules="rulesB2b.store_name"
                  single-line
                  outlined
                  class="rounded-lg text-body-1"
                  height="45"
                  dense
                  placeholder="Nama Toko"
                  hide-details="auto"
                  @focus="() => (responseError.store_name = '')"
                  :error-messages="responseError.store_name"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="align-center">
              <v-col cols="12" sm="3" class="py-xs-0"
                ><div class="d-block text-subtitle-2 font-weight-bold black--text">
                  Nomor Handphone
                </div></v-col
              >
              <v-col cols="12" sm="7">
                <v-text-field
                  v-model="paramsB2b.store_mobilephone"
                  :rules="rulesB2b.store_mobilephone"
                  single-line
                  outlined
                  class="rounded-lg text-body-1"
                  height="45"
                  dense
                  placeholder="Nomor Handphone"
                  hide-details="auto"
                  @focus="() => (responseError.store_mobilephone = '')"
                  :error-messages="responseError.store_mobilephone"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="align-center">
              <v-col cols="12" sm="3" class="py-xs-0"
                ><div class="d-block text-subtitle-2 font-weight-bold black--text">
                  Alamat Toko
                </div></v-col
              >
              <v-col cols="12" sm="7">
                <v-textarea
                  v-model="paramsB2b.store_address"
                  :rules="rulesB2b.store_address"
                  single-line
                  outlined
                  class="rounded-lg text-body-1"
                  dense
                  placeholder="Alamat Toko"
                  hide-details="auto"
                  @focus="() => (responseError.store_address = '')"
                  :error-messages="responseError.store_address"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row class="align-center">
              <v-col cols="12" sm="3" class="py-xs-0"
                ><div class="d-block text-subtitle-2 font-weight-bold black--text">
                  Kurir Toko
                </div></v-col
              >
              <v-col cols="12" sm="7">
                <v-autocomplete
                  v-model="paramsB2b.store_courier"
                  auto-select-first
                  multiple
                  :items="courier"
                  hide-details="auto"
                  @focus="() => (responseError.store_courier = '')"
                  :error-messages="responseError.store_courier"
                  item-value="courier_code"
                  item-text="courier_name"
                  outlined
                  dense
                  :rules="rulesB2b.store_courier"
                  placeholder="Kurir Toko"
                >
                </v-autocomplete>
              </v-col>
            </v-row>

            <v-row class="align-center">
              <v-col cols="12" sm="3" class="py-xs-0"
                ><div class="d-block text-subtitle-2 font-weight-bold black--text">
                  Perizinan
                </div></v-col
              >
              <v-col cols="12" sm="7">
                <v-autocomplete
                  v-model="paramsB2b.permission"
                  auto-select-first
                  multiple
                  :items="listPermission"
                  hide-details="auto"
                  @focus="() => (responseError.permission = '')"
                  :error-messages="responseError.permission"
                  outlined
                  dense
                  :rules="rulesB2b.permission"
                  placeholder="Perizinan"
                >
                </v-autocomplete>
              </v-col>
            </v-row>

            <!-- hint="Klik + Ctrl pada gambar untuk multiple upload" -->
            <v-row class="align-center">
              <v-col cols="12" sm="3" class="py-xs-0"
                ><div class="d-block text-subtitle-2 font-weight-bold black--text">
                  Gambar
                </div></v-col
              >
              <v-col cols="12" sm="7">
                <v-file-input
                  @change="createImage($event)"
                  id="inputPermissionImg"
                  ref="fileuploadB2b"
                  placeholder="Upload Gambar"
                  persistent-hint
                  hint="Klik Ctrl + gambar untuk multiple upload"
                  chips
                  accept="image/*"
                  multiple
                  small-chips
                  outlined
                  prepend-icon=""
                  truncate-length="50"
                  :rules="rulesB2b.image"
                  @focus="() => (responseError.image = '')"
                  :error-messages="responseError.image"
                ></v-file-input>
                <!-- <v-text-field v-model="paramsB2b.image" :rules="rulesB2b.image" single-line outlined class="rounded-lg text-body-1" height="45" dense placeholder="Gambar" hide-details="auto"></v-text-field> -->
              </v-col>
            </v-row>

            <v-row class="align-start">
              <v-col cols="12" sm="3" class="py-xs-0"
                ><div class="d-block text-subtitle-2 font-weight-bold black--text">
                  Catatan
                </div></v-col
              >
              <v-col cols="12" sm="7">
                <v-textarea
                  v-model="paramsB2b.note"
                  single-line
                  outlined
                  class="rounded-lg text-body-1"
                  placeholder="Catatan"
                  hide-details="auto"
                  @focus="() => (responseError.note = '')"
                  :error-messages="responseError.note"
                  no-resize
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr />
            <v-btn
              outlined
              @click="dialogB2b = false"
              :loading="loadingProcess"
              class="my-2 px-5 text-capitalize"
            >
              Batal
            </v-btn>
            <v-btn
              color="primary"
              outlined
              @click="confirmationB2b"
              :loading="loadingProcess"
              class="my-2 px-5 ml-2 text-capitalize white--text"
            >
              Simpan
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import moment from "moment";

const defaultInput = () => ({
  company_name: "",
  store_name: "",
  store_mobilephone: "",
  store_address: "",
  store_courier: [],
  permission: [],
  image: [],
  note: ""
});

export default {
  props: ["profile"],
  data() {
    return {
      loading: false,
      loadingProcess: false,
      isMobile: false,
      imgUpload: {},
      stores_image: "",
      listPermission: ["BPOM", "MUI", "Dll"],
      dialogB2b: false,
      paramsB2b: defaultInput(),
      imgPreview: [],
      onEdit: false,
      store_description: "",
      descriptionRules: [
        v => !!v || "Nama Toko tidak boleh kosong",
        v => v.length <= 200 || "Deskripsi maksimal 200 karakter"
      ],
      rulesB2b: {
        company_name: [v => !!v || "Nama Perusahaan tidak boleh kosong"],
        store_name: [v => !!v || "Nama Toko tidak boleh kosong"],
        store_mobilephone: [v => !!v || "Nomor Handphone tidak boleh kosong"],
        store_address: [v => !!v || "Alamat Toko tidak boleh kosong"],
        store_courier: [v => v.length > 0 || "Kurir tidak boleh kosong"],
        permission: [v => v.length > 0 || "Izin tidak boleh kosong"],
        image: [v => !!v || "Gambar tidak boleh kosong"]
      }
    };
  },

  computed: {
    ...mapState("auth", ["userData"]),
    ...mapState("storeSeller", ["detailStore", "response"]),
    ...mapState("options", ["courier"]),
    ...mapState("b2bSeller", ["responseError"])
  },

  methods: {
    ...mapActions("storeSeller", ["getStoreDetail", "uploadImage", "saveDescription"]),
    ...mapActions("b2bSeller", ["requestB2b", "uploadImageB2b", "canRequestB2b"]),
    ...mapActions("options", ["getCourier"]),
    ...mapMutations(["makeAlert"]),

    cancelEdit() {
      this.onEdit = false;
    },
    async saveEdit() {
      this.loadingProcess = await true;
      await this.saveDescription({
        description: this.store_description
      })
        .then(() => {
          this.getStoreDetail();
          this.onEdit = false;
          this.loadingProcess = false;
        })
        .catch(() => {
          this.makeAlert({
            code: "error_response",
            type: "error",
            message: "Gagal mengubah deskripsi toko",
            show: true
          });
          this.loadingProcess = false;
        });
    },
    formatDateText(params, format) {
      let dates = params ? new Date(params) : null;
      return dates ? moment(dates).format(format) : null;
    },
    async openUpload() {
      const input = await document.getElementById("inputImage");
      input.click();
    },
    openConfirmB2b() {
      this.canRequestB2b().then(async () => {
        await this.getCourier();
        this.dialogB2b = await true;
      });
    },
    confirmationB2b() {
      if (this.$refs.formB2b.validate()) {
        var dimensions = [];
        this.imgPreview.forEach(el => {
          dimensions.push(
            new Promise(resolve => {
              let formData = new FormData();
              formData.append("image", el.file);
              this.uploadImageB2b(formData).then(res => {
                resolve(res.product_image);
              });
            })
          );
        });

        Promise.all(dimensions)
          .then(dims => {
            this.paramsB2b.image = dims;
            this.requestB2b(this.paramsB2b).then(() => {
              this.getStoreDetail();
              this.$refs.formB2b.resetValidation();
              this.$refs.fileuploadB2b.clearableCallback();
              this.imgPreview = [];
              this.paramsB2b = defaultInput();
              this.loadingProcess = false;
              this.dialogB2b = false;
            });
          })
          .catch(function(err) {
            console.log(err);
            this.loadingProcess = false;
          });
      }
    },
    createImage(event) {
      var dimensions = [];
      event.forEach(el => {
        dimensions.push(
          new Promise(function(resolve) {
            var reader = new FileReader();
            reader.onload = e => {
              resolve({
                img: e.target.result,
                file: el
              });
            };
            reader.readAsDataURL(el);
          })
        );
      });

      Promise.all(dimensions)
        .then(res => {
          if (this.imgPreview.length + res.length > 10)
            this.makeAlert({
              code: "error_response",
              type: "error",
              message: "Gambar maksimal 10",
              show: true
            });

          res.splice(10 - this.imgPreview.length, res.length - 1);
          this.imgPreview = [...new Set([...this.imgPreview, ...res])];
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    handleFileUpload(event) {
      this.loadingProcess = true;
      let formData = new FormData();
      formData.append("image", event);
      this.uploadImage(formData)
        .then(response => {
          this.stores_image = response;
          this.makeAlert({
            code: "success",
            type: "success",
            message: this.response.message,
            show: true
          });
          this.getStoreDetail();
          this.imgUpload = {};
          this.loadingProcess = false;
        })
        .catch(() => {
          this.imgUpload = {};
          this.loadingProcess = false;
        });
    },
    openModule(link) {
      this.$router.push({ path: link });
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    getUrlReferal() {
      let link = `${process.env.VUE_APP_DOMAIN}/store/${this.detailStore.store_slug}`;
      if (this.userData.user_network_id > 0) {
        link += `/${this.userData.user_mobilephone}`;
      }
      return link;
    },
    copyme() {
      var copyText = document.getElementById("inputCopy");
      copyText.setAttribute("type", "text");
      copyText.select();
      try {
        document.execCommand("copy");
        setTimeout(() => {
          this.$store.commit("makeAlert", {
            code: "success",
            type: "success",
            message: "Tautan berhasil disalin",
            show: true
          });
        }, 300);
      } catch (err) {
        alert("Oops, tidak dapat menyalin");
      }
      copyText.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    }
  },

  async created() {
    this.$store.dispatch("setPageTitle", `Profil Seller`);
    this.loading = await true;
    this.stores_image = this.detailStore.store_image;
    this.loading = false;
  }
};
</script>
